import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'endpointsColor'
})
export class EndpointsColorPipe implements PipeTransform {
    constructor() {}
    transform(register) {
        if(register && register.activeCalls && register.activeCalls > 0){
            return 'success';
        }else {
            if(register && register.plcmH323Identity){
                if(register.plcmH323Identity.h323RegistrationState == 'ACTIVE'){
                    return 'success';
                } else if(register.plcmH323Identity.h323RegistrationState == 'INACTIVE'){
                    return 'danger';
                } else if(register.plcmH323Identity.h323RegistrationState == 'QUARANTINED'){
                    return 'warning';
                } else {
                    return 'secondary';
                }
            }else if(register && register.plcmSipIdentityV2){
                if(register.plcmSipIdentityV2.sipRegistrationState == 'ACTIVE'){
                    return 'success';
                } else if(register.plcmSipIdentityV2.sipRegistrationState == 'INACTIVE'){
                    return 'danger';
                } else if(register.plcmSipIdentityV2.sipRegistrationState == 'QUARANTINED'){
                    return 'warning';
                } else {
                    return 'secondary';
                }
            } else {
                return 'secondary';
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeEndpointsColor.ts